import { ActionIcon, ButtonGroup, Menu, Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { GraphicsSettings } from 'app/modules/wallforming/components/setting-container/GraphicsSettings';
import { PPMFilter } from 'app/modules/wallforming/components/setting-container/PPMFilter';
import { SettingNavigator } from 'app/modules/wallforming/components/setting-container/SettingNavigator';
import { SettingView } from 'app/modules/wallforming/components/setting-container/types/settingView';
import { UnitSelector } from 'app/modules/wallforming/components/setting-container/UnitSelector';

interface SettingNavigatorContainerProps {
    isCopilotFloating?: boolean;
    onSettingViewSelect?: (settingView: SettingView) => void;
}

export const SettingNavigatorContainer = ({
    isCopilotFloating = false,
    onSettingViewSelect
}: SettingNavigatorContainerProps) => {
    const { t } = useTranslation();

    return (
        <div
            className="relative h-full w-[48px] shrink-0 bg-background-default border border-solid border-border-ultra-light text-text-placeholder"
            data-setting-navigator
        >
            <div className="flex flex-col h-auto justify-start mt-3.5">
                <ButtonGroup
                    orientation="vertical"
                    style={{
                        transform: 'rotate(90deg)',
                        transformOrigin: 'center'
                    }}
                    variant={variants.buttonGroup.small}
                >
                    <SettingNavigator isCopilotFloating={isCopilotFloating} onSettingViewSelect={onSettingViewSelect} />
                </ButtonGroup>
            </div>

            <Menu closeOnItemClick={false} position="left-end" shadow="md">
                <Menu.Target>
                    <div className="absolute bottom-14 left-1/2 transform -translate-x-1/2">
                        <Tooltip label={t('labelGraphicOptions')} position="left" variant={variants.tooltip.left}>
                            <ActionIcon className="bg-background-gray-ultra-light hover:bg-background-gray! pointer-events-auto action-icon-medium icon-lg!">
                                tune
                            </ActionIcon>
                        </Tooltip>
                    </div>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Label>{t('labelGraphicOptions')}</Menu.Label>
                    <Menu.Divider />
                    <GraphicsSettings />
                </Menu.Dropdown>
            </Menu>

            <Menu closeOnItemClick={false} position="left-end" shadow="md">
                <Menu.Target>
                    <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2">
                        <Tooltip label={t('labelOptions')} position="left" variant={variants.tooltip.left}>
                            <ActionIcon className="bg-background-gray-ultra-light hover:bg-background-gray! pointer-events-auto action-icon-medium icon-lg">
                                settings
                            </ActionIcon>
                        </Tooltip>
                    </div>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Label>{t('labelOptions')}</Menu.Label>
                    <Menu.Divider />
                    <PPMFilter />
                    <Menu.Divider />
                    <UnitSelector />
                </Menu.Dropdown>
            </Menu>
        </div>
    );
};
